import { Reveal, SectionLabel, LuxBg } from "../Reveal";
import { PAIN_PARAGRAPHS, TRANSFORMS } from "../../content";

export const Transformation = () => (
  <section className="relative py-28 md:py-36 px-6 sm:px-10 lg:px-16 xl:px-24" data-testid="transformation-section">
    <LuxBg n={2} />
    <div className="grid lg:grid-cols-2 gap-14 lg:gap-24">
      <div>
        <Reveal><SectionLabel num="006" text="WE'VE BEEN THERE" /></Reveal>
        <Reveal delay={0.05}>
          <h2 className="serif font-black uppercase tracking-tight text-3xl md:text-4xl text-white mb-8">
            IF YOU&apos;RE LIKE MOST <span className="text-[#FE0000]">VETERANS &amp; ACTIVE-DUTY BUYERS</span> I WORK WITH...
          </h2>
        </Reveal>
        {PAIN_PARAGRAPHS.map((p, i) => (
          <Reveal key={i} delay={0.1 + i * 0.06}>
            <p className="text-white text-[17px] leading-[1.8] mb-5" data-testid={`pain-paragraph-${i}`}>{p}</p>
          </Reveal>
        ))}
      </div>
      <div className="lg:pt-16">
        <Reveal delay={0.1}>
          <div className="rounded-lg border border-[#FE0000]/25 bg-[#FE0000]/[0.04] p-8">
            <div className="mono text-[13px] tracking-[0.3em] text-[#FFC631] mb-8" data-testid="transformation-header">
              HERE&apos;S WHAT CHANGES AFTER THIS WEBINAR:
            </div>
            <ul className="space-y-6">
              {TRANSFORMS.map((t, i) => (
                <li key={i} className="flex gap-4 text-[17px] text-white leading-relaxed" data-testid={`transform-bullet-${i}`}>
                  <span className="text-[#FE0000] font-bold shrink-0">→</span>
                  {t}
                </li>
              ))}
            </ul>
            <button
              data-testid="transformation-cta"
              data-cta
              onClick={() => document.getElementById("register")?.scrollIntoView({ behavior: "smooth" })}
              className="w-full mt-10 bg-[#FFE100] text-[#12264A] font-bold text-sm uppercase tracking-wide py-4 rounded-md btn-slide"
            >
              ✓ RESERVE MY FREE SEAT
            </button>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
